export default __webpack_public_path__ + "static/media/9.322b75f2.jpg";